import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import React from 'react';
import styles from '@/styles/Corporate.module.css';
import { useRouter } from 'next/router';

import { getOrFetchCorporateData, getOrFetchBlogs } from '@/utils/corporateCalls';
import { getLayoutProps } from '@/utils/layout/layout';
import BlogPageSection from '@/components/BlogPage/BlogPage';
import { CustomMetaHead } from '@/components/CustomMetaHead/CustomMetaHead';

export default function Blogs({ blogs, responsiveLogo }) {
  const router = useRouter();

  const { page, slug } = router.query;
  const blogData = blogs.data.filter(el => el.content.slug == slug).map(el => el.content);
  const filteredBlogs = blogs.included.blob_posts.filter(blog1 =>
    blogData[0].blog_posts.some(blog2 => blog2.id === blog1.id)
  );

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <CustomMetaHead metadata={blogData[0].metadata} />

      <main className={styles.mainContainer}>
        <div className={styles.categoriesContainer}>
          <BlogPageSection data={blogData[0]} blogs={filteredBlogs} page={page} />
        </div>
      </main>
    </>
  );
}

Blogs.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticPaths({ locales }) {
  const [blogs] = await Promise.all([getOrFetchBlogs()]);
  const paths = blogs.data.data.map(path => {
    return {
      params: { slug: [path.content.slug] },
    };
  });

  const localizedPaths = [];
  for (const locale of locales) {
    for (const path of paths) localizedPaths.push({ ...path, locale });
  }

  return { paths: localizedPaths, fallback: false };
}

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: blogData }] = await Promise.all([getOrFetchCorporateData('blogs_page', context.locale)]);

  const blogs = blogData;

  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      blogs,
      messages,
    },
  };
}
